import React from "react";

const GlobalUnrestImpact = () => {
  return (
    <div style={styles.page}>
      {/* Hero */}
      <div style={styles.hero}>
        <h1 style={styles.heroTitle}>Global Unrest and Its Impact</h1>
        <p style={styles.heroSubtitle}>
          Geopolitical Tensions Shaping the Present World
        </p>
      </div>

      {/* Content */}
      <div style={styles.container}>
        <section style={styles.section}>
          <h2 style={styles.heading}>Introduction</h2>
          <p style={styles.text}>
            The present world is experiencing heightened global unrest driven
            by geopolitical conflicts, economic instability, energy security
            concerns, and ideological divisions. These disruptions affect not
            only the countries directly involved but also global trade,
            financial markets, food security, and international cooperation.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Global Economic and Social Effects</h2>
          <p style={styles.text}>
            Ongoing conflicts and political instability have disrupted supply
            chains, increased inflation, and weakened investor confidence.
            Energy prices, food costs, and essential commodities remain volatile,
            impacting both developed and developing nations. Social unrest,
            migration pressures, and humanitarian crises have intensified,
            challenging global stability.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>United States: Global Leadership Challenges</h2>
          <p style={styles.text}>
            The United States continues to play a central role in global
            geopolitics through diplomatic, economic, and military engagement.
            Domestic political polarization, rising public debt, and global
            security commitments place pressure on policymaking. International
            conflicts and strategic rivalries influence U.S. foreign policy,
            defense spending, and economic priorities.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Ukraine Conflict and European Stability</h2>
          <p style={styles.text}>
            The ongoing conflict in Ukraine has significantly altered the
            geopolitical landscape of Europe. It has resulted in humanitarian
            challenges, energy shortages, and increased defense spending across
            the region. The conflict has also reshaped global alliances and
            highlighted vulnerabilities in energy dependence and regional
            security frameworks.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Russia: Sanctions and Strategic Isolation</h2>
          <p style={styles.text}>
            Russia faces extensive economic sanctions and diplomatic isolation,
            affecting its trade, financial systems, and technological access.
            While Russia continues to adapt through alternative trade partners
            and domestic measures, prolonged tensions contribute to global
            uncertainty, energy market disruptions, and long-term geopolitical
            realignment.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Venezuela: Economic Crisis and Regional Impact</h2>
          <p style={styles.text}>
            Venezuela’s prolonged economic and political crisis has led to high
            inflation, reduced industrial output, and large-scale migration.
            Regional neighbors face challenges related to refugee inflows,
            labor markets, and social services. Venezuela’s energy resources
            remain strategically significant amid global supply concerns.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Impact on Global Security and Diplomacy</h2>
          <p style={styles.text}>
            Rising global unrest has increased military spending and reduced
            diplomatic trust among nations. Multilateral institutions face
            challenges in conflict resolution, while emerging powers seek
            greater influence. Cybersecurity threats, misinformation, and
            hybrid warfare have become key elements of modern conflict.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Future Outlook</h2>
          <p style={styles.text}>
            The future global order will depend on diplomatic engagement,
            economic resilience, and international cooperation. Addressing
            global unrest requires dialogue, humanitarian support, sustainable
            development, and renewed commitment to multilateral solutions.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Conclusion</h2>
          <p style={styles.text}>
            Global unrest has far-reaching consequences that extend beyond
            borders. The situations involving the United States, Ukraine,
            Russia, and Venezuela illustrate how interconnected the modern
            world has become. Long-term stability will depend on balanced
            policies, global cooperation, and efforts to reduce conflict-driven
            uncertainty.
          </p>
        </section>
      </div>

      {/* Footer */}
      <footer style={styles.footer}>
        <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '20px', marginBottom: '20px' }}>
          <p style={{ fontSize: '0.75rem', color: '#64748b', fontStyle: 'italic', margin: '0 0 20px 0' }}>
            Article by <strong>Mangalorehub.com Business Correspondent</strong>
          </p>
        </div>
        © 2026 Global Affairs | Current World Analysis
      </footer>
    </div>
  );
};

const styles = {
  page: {
    fontFamily: "'Inter', Arial, sans-serif",
    backgroundColor: "#f8fafc",
    minHeight: "100vh",
    color: "#0f172a",
  },
  hero: {
    background: "linear-gradient(135deg, #7c2d12, #991b1b)",
    color: "#ffffff",
    textAlign: "center",
    padding: "25px 20px",
  },
  heroTitle: {
    fontSize: "1.40rem",
    fontWeight: "600",
    marginBottom: "10px",
  },
  heroSubtitle: {
    fontSize: "1.0rem",
    opacity: 0.9,
  },
  container: {
    maxWidth: "900px",
    margin: "-40px auto 0",
    background: "#ffffff",
    borderRadius: "16px",
    padding: "40px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
  },
  section: {
    marginBottom: "35px",
  },
  heading: {
    fontSize: "1.2rem",
    color: "#991b1b",
    borderLeft: "4px solid #991b1b",
    paddingLeft: "12px",
    marginBottom: "10px",
  },
  text: {
    fontSize: ".90rem",
    lineHeight: "1.5",
  },
  footer: {
    textAlign: "center",
    margin: "40px 0",
    fontSize: "0.9rem",
    color: "#64748b",
  },
};

export default GlobalUnrestImpact;
